'use client';

import { PropsWithChildren } from 'react';
import { useShell } from '@/providers';
import useIsRegistryRoute from '@/hooks/useIsRegistryRoute';
import { Box, Stack } from '@/primitives';
import DesktopToolbar from './toolbar/DesktopToolbar';
import MobileToolbar from './toolbar/MobileToolbar';
import ShellSidebar from './ShellSidebar';
import ShellFooter from './ShellFooter';
import { MainContentErrorBoundary } from '@/components/errorboundary/MainContentErrorBoundary';
import {
  FOOTER_HEIGHT,
  NAV_HEIGHT,
  PAGE_PADDING,
  PAGE_PADDING_TOP,
} from '@/configs/layout';

export function Shell({ children }: PropsWithChildren) {
  const { isMobile } = useShell();
  const isRegistryRoute = useIsRegistryRoute();

  return (
    <Stack
      id="shell"
      sx={{
        mt: `${NAV_HEIGHT}px`,
        ...(!isRegistryRoute && {
          height: `calc(100vh - ${NAV_HEIGHT}px)`,
          overflowY: 'auto',
          overflowX: 'hidden',
        }),
      }}
    >
      {isMobile ? <MobileToolbar /> : <DesktopToolbar />}
      {isRegistryRoute ? (
        <Stack
          direction="row"
          height={`calc(100vh - ${NAV_HEIGHT}px) - ${FOOTER_HEIGHT}px`}
        >
          <ShellSidebar />
          <Box
            component="main"
            id="main"
            sx={{
              flex: 1,
              padding: isRegistryRoute
                ? `${PAGE_PADDING_TOP}px ${PAGE_PADDING}px 0`
                : 0,
              height: `calc(100vh - ${NAV_HEIGHT}px - ${FOOTER_HEIGHT}px)`,
              overflowY: 'auto',
              overflowX: 'hidden',
            }}
          >
            <MainContentErrorBoundary>{children}</MainContentErrorBoundary>
          </Box>
        </Stack>
      ) : (
        <Box component="main" flex={1}>
          <MainContentErrorBoundary>{children}</MainContentErrorBoundary>
        </Box>
      )}
      <ShellFooter />
    </Stack>
  );
}
